module.exports = __webpack_public_path__ + "files/a68e350abe75833b911ebe20d30a53af.png";